import * as React from 'react';

const { useState, useEffect } = React;

export interface LoadExternalSVGProps {
  url: string;
}

const LoadExternalSVG = React.memo(({ url }: LoadExternalSVGProps) => {
  const [spriteSheet, setSpriteSheet] = useState(null);

  useEffect(() => {
    fetch(url)
      .then((data) => data.text())
      .then((text) => {
        setSpriteSheet(text);
      });
  }, []);

  return <div style={{ display: "none" }} dangerouslySetInnerHTML={{ __html: spriteSheet }} />; // eslint-disable-line
});

export default LoadExternalSVG;
